module.exports = __webpack_public_path__ + "static/Pattern-087d8053002d551b5c59b1d2c7d8db79.png";